import * as Sentry from '@sentry/react'

export const getSentryConfig = (dsn: string): Sentry.BrowserOptions => ({
  dsn,
  tunnel: '/api/public/sentryTunnel',
  sendDefaultPii: false,

  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_SPRING_PROFILES_ACTIVE,

  integrations: [Sentry.replayIntegration()],

  replaysOnErrorSampleRate: 1,
  tracesSampleRate: 0,
  sampleRate: 1,
  ignoreErrors: ['GraphQL error: Acesso não permitido.', /^ResizeObserver loop/],
})
